<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印发货通知单"
      width="1000px"
      class="printDeliveryNote">
    <div style="border-bottom:1px solid #000;font-weight:700">打印设置</div>
    <el-form :inline="true" label-width="80px">
      <el-form-item label="订单编号">
        <el-checkbox v-model="orderNoVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="物料编号">
        <el-checkbox v-model="materialNoVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="物料名称">
        <el-checkbox v-model="materialNameVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="规格型号">
        <el-checkbox v-model="specificationVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="客户型号">
        <el-checkbox v-model="customerSpecificationVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="数量">
        <el-checkbox v-model="quantityVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="实发数量">
        <el-checkbox v-model="actualQuantityVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="备注">
        <el-checkbox v-model="noteVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="订单备注">
        <el-checkbox v-model="orderRowNoteVisible" label="打印"/>
      </el-form-item>
      <el-form-item label="供应商信息">
        <el-checkbox v-model="orderSupplierVisible" label="打印"/>
      </el-form-item>
    </el-form>
    <div>
      <div id="printDeliveryContent1" :loading="contentLoading">
        <div v-for="(item, index) in deliveryNotes" :key="index" class="deliveryNotetem">
          <table class="codeBox" cellspacing="0">
            <tr>
              <td rowspan="4" v-if="orderSupplierVisible" class="imgBox" style="min-width:150px">
                <div :id="'qrCode' + item.billNo" align="center" style="margin: 4px;"/>
              </td>
              <td rowspan="3" v-else class="imgBox" style="min-width:150px">
                <div :id="'qrCode' + item.billNo" align="center" style="margin: 4px;"/>
              </td>
              <td colspan="5" style="text-align: center; font-weight: 700">发货通知单</td>
            </tr>
            <tr>
              <td colspan="3">发货单号:{{item.erpBillNo}}</td>
              <td>制单人：{{item.creatorName}}</td>
              <td>制单时间：{{item.createTime}}</td>
            </tr>
            <tr>
              <td colspan="4">购货单位：{{item.showCustomerName}}</td>
              <td>发货日期：{{item.printTime}}</td>
              <!--            <td colspan="2">购货单位：{{item.customerName}}</td>-->
            </tr>
            <tr v-if="orderSupplierVisible">
              <td colspan="5">供应商：鸿康电器有限公司</td>
            </tr>
            <tr>
              <td colspan="4">
                <div v-if="!isPrint" style="display:flex;">
                <span style="width: 70px;">发货地址:</span>
                <el-input v-model="item.deliveryAddress"/>
              </div>
                <div v-if="isPrint">
                  <span>发货地址:{{item.deliveryAddress}}</span>
                </div></td>
              <td>
                <div v-if="!isPrint" style="display:flex;">
                  <span style="width: 70px;">联系人:</span>
                  <el-input v-model="item.deliveryContact"/>
                </div>
                <div v-if="isPrint">
                  <span>联系人:{{item.deliveryContact}}</span>
                </div>
              </td>
              <td>
                <div v-if="!isPrint" style="display:flex;">
                  <span style="width: 70px;">联系方式:</span>
                  <el-input v-model="item.deliveryTel"/>
                </div>
                <div v-if="isPrint">
                  <span>联系方式:{{item.deliveryTel}}</span>
                </div>
              </td>
            </tr>
            <tr>
              <td colspan="6">备注:{{item.deliveryNote1}}</td>
            </tr>
            <tr>
              <td colspan="8">
                <table cellspacing="0" style="width:100%;margin: 0px;">
                  <tr>
                    <td style="padding: 0 !important;width: 50px;min-width: 50px !important;">序号</td>
                    <td v-if="orderNoVisible">订单编号</td>
                    <td v-if="materialNoVisible">物料编号</td>
                    <td v-if="materialNameVisible">物料名称</td>
                    <td v-if="specificationVisible">规格型号</td>
                    <td v-if="customerSpecificationVisible">客户型号</td>
                    <td v-if="quantityVisible" style="padding: 0 !important;width: 80px;">数量</td>
                    <td v-if="actualQuantityVisible" style="padding: 0 !important;width: 80px;">实发数量</td>
                    <td v-if="noteVisible">备注</td>
                    <td v-if="orderRowNoteVisible">订单备注</td>
                  </tr>
                  <tr v-for="(i,index1) in item.deliveryBillDetails" :key="index1" style="height: 10px;">
                    <!--                    <td v-if="orderNoVisible">{{i.salesOrderNO}}</td>-->
                    <td style="padding: 0 !important;width: 50px;">{{i.rowIndex}}</td>
                    <td v-if="orderNoVisible">{{i.erpSourceBillNo}}</td>
                    <td v-if="materialNoVisible">{{i.materialNo}}</td>
                    <td v-if="materialNameVisible">{{i.materialName}}</td>
                    <td v-if="specificationVisible">{{i.specification}}</td>
                    <td v-if="customerSpecificationVisible">
                      <div v-if="!isPrint">
                        <el-input v-model="i.customerSpecification"/>
                      </div>
                      <div v-if="isPrint">
                        <span>{{i.customerSpecification}}</span>
                      </div>
                    </td>
                    <td v-if="quantityVisible" style="padding: 0 !important;width: 80px;">{{i.quantity}}</td>
                    <td v-if="actualQuantityVisible" style="padding: 0 !important;width: 80px;">
                      <div v-if="!isPrint">
                        <el-input v-model="i.actualQuantity"/>
                      </div>
                      <div v-if="isPrint">
                        <span>{{i.actualQuantity}}</span>
                      </div>
                    </td>
                    <td v-if="noteVisible">{{i.note}}</td>
                    <td v-if="orderRowNoteVisible">
                      <!--                      {{i.orderRowNote}}-->
                      <div v-if="!isPrint">
                        <el-input v-model="i.orderRowNote" type="textarea" autosize/>
                      </div>
                      <div v-if="isPrint">
                        <span>{{i.orderRowNote}}</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <!--          <el-table :data="item.deliveryBillDetails" border style="width: 100%!important;">-->
          <!--            <el-table-column v-if="orderNoVisible" prop="salesOrderNO" label="订单编号" min-width="110"/>-->
          <!--            <el-table-column v-if="materialNoVisible" prop="materialNo" label="物料编号" min-width="120"/>-->
          <!--            <el-table-column v-if="materialNameVisible" prop="materialName" label="物料名称"/>-->
          <!--            <el-table-column v-if="specificationVisible" prop="specification" label="规格型号" min-width="150"/>-->
          <!--            <el-table-column-->
          <!--                v-if="customerSpecificationVisible"-->
          <!--                prop="customerSpecification"-->
          <!--                label="客户型号"-->
          <!--                align="left"-->
          <!--                min-width="150"/>-->
          <!--            <el-table-column prop="quantity" label="数量" align="center" min-width="60"/>-->
          <!--            <el-table-column v-if="noteVisible" prop="note" label="备注"/>-->
          <!--            <el-table-column v-if="orderRowNoteVisible" prop="orderRowNote" label="订单备注"/>-->
          <!--          </el-table>-->
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button @click="editPrint">编辑</el-button>
      <el-button type="primary" v-print="printOption" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  import moment from "moment";

  export default {
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        orderNoVisible: true,
        materialNoVisible: true,
        materialNameVisible: true,
        specificationVisible: true,
        customerSpecificationVisible: true,
        quantityVisible: true,
        actualQuantityVisible: true,
        noteVisible: true,
        orderRowNoteVisible: true,
        orderSupplierVisible:true,
        isPrint: false,
        ids: [],
        printOption: {
          id: "printDeliveryContent1",
          preview: false,
          popTitle: "打印",
          previewPrintBtnLabel: "打印",
          clickMounted() {
          },
        },
        deliveryNotes: [
          {
            billNo: "",
            outStockTypeName: "",
            requireDate: "",
            relBillNo: "",
            note: "",
            customerName: "",
            showCustomerName: "",
            printTime: "",
            outStockBillDetailVOS: [],
          },
        ],
      };
    },

    methods: {
      open(ids) {
        this.isPrint = false;
        this.dialogVisible = true;
        this.getData(ids);
      },
      getData(ids) {
        this.ids = [];
        this.$http.get("basic", `sd/DeliveryBills/getListByDetailIds/${ids}`).then((resp) => {
          this.deliveryNotes = resp.data;
          for (let item of this.deliveryNotes) {
            this.ids.push(item.pkid);
            item.printTime = moment(new Date()).format("YYYY-MM-DD");
            this.$nextTick(() => {
              document.getElementById("qrCode" + item.billNo).innerHTML = "";
              this.bindQRCode(item.billNo);
            });
          }
          this.contentLoading = false;
        });
      },
      bindQRCode(billNo) {
        let text = billNo;
        new QRCode(document.getElementById("qrCode" + billNo), {
          text: text,
          width: 120,
          height: 120,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },
      editPrint(){
        this.isPrint=false;
      },
      print() {
        this.isPrint = true;
        this.$http.post("basic", "sd/DeliveryBills/updatePrint", this.ids).then(() => {
        });
        // this.$nextTick(() => {
        //   document.body.innerHTML = document.getElementById("content1").parentNode.innerHTML;
        //   window.print();
        //   window.location.reload();
        //
        //   this.$http.post("basic", "sd/DeliveryBills/updatePrint", this.ids).then(() => {
        //   });
        //   return false;
        // });
      },
    },
  };
</script>

<style scoped>
/* 正文样式 */
.deliveryNotetem {
  margin-bottom: 20px;
  page-break-before: always;
}

.codeBox {
  width: 100%;
  height: 150px;
  margin-bottom: 5px;
}

.codeBox td {
  border: 1px solid;
  border-right: 0;
  border-top: 0;
  min-width: 50px;
}

.codeBox tr td:last-child {
  border-right: 1px solid;
}

.codeBox tr:first-child td {
  border-top: 1px solid;
}

.imgBox {
  width: 150px;
  padding: 10px;
  box-sizing: border-box;
}

.imgBox img {
  width: 100%;
  height: 100%;
}
</style>

<style>
.printDeliveryNote .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.printDeliveryNote .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.printDeliveryNote .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.printDeliveryNote .el-divider--horizontal {
  margin: 10px 0;
}

.printDeliveryNote .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>